import Main from '@/components/main'
// import parentView from '@/components/parent-view'

/**
 * iview-admin中meta除了原生参数外可配置的参数:
 * meta: {
 *  title: { String|Number|Function }
 *         显示在侧边栏、面包屑和标签栏的文字
 *         使用'{{ 多语言字段 }}'形式结合多语言使用，例子看多语言的路由配置;
 *         可以传入一个回调函数，参数是当前路由对象，例子看动态路由和带参路由
 *  hideInBread: (false) 设为true后此级路由将不会出现在面包屑中，示例看QQ群路由配置
 *  hideInMenu: (false) 设为true后在左侧菜单不会显示该页面选项
 *  notCache: (false) 设为true后页面在切换标签后不会缓存，如果需要缓存，无需设置这个字段，而且需要设置页面组件name属性和路由配置的name一致
 *  access: (null) 可访问该页面的权限数组，当前路由设置的权限会影响子路由
 *  icon: (-) 该页面在左侧菜单、面包屑和标签导航处显示的图标，如果是自定义图标，需要在图标名称前加下划线'_'
 *  beforeCloseName: (-) 设置该字段，则在关闭当前tab页时会去'@/router/before-close.js'里寻找该字段名对应的方法，作为关闭前的钩子函数
 * }
 */

export default [
  {
    path: '/login/:platformId',
    name: 'login',
    meta: {
      title: 'Login - 登录',
      hideInMenu: true
    },
    component: () => import('@/view/login/login.vue')
  },
  {
    path: '/',
    component: Main,
    children: [
      {
        path: '/home',
        name: 'home',
        meta: {notCache: true, title: "首页"},
        component: () => import('@/view/home/home')
      }
    ]
  },
  {
    path: '/sorting',
    component: Main,
    children: [
      {
        path: '/sorting/weightSorting',
        name: 'weightSorting',
        meta: {notCache: true, title: "计重商品分拣"},
        component: () => import('@/view/sorting/weightSorting')
      }
    ]
  },
  {
    path: '/sorting',
    component: Main,
    children: [
      {
        path: '/sorting/standardSorting',
        name: 'standardSorting',
        meta: {notCache: true, title: "不计重商品分拣"},
        component: () => import('@/view/sorting/standardSorting')
      }
    ]
  },
  {
    path: '/sorting',
    component: Main,
    children: [
      {
        path: '/sorting/orderSorting',
        name: 'orderSorting',
        meta: {notCache: true, title: "订单分拣"},
        component: () => import('@/view/sorting/orderSorting')
      }
    ]
  },
  {
    path: '/sorting',
    component: Main,
    children: [
      {
        path: '/sorting/diffSorting',
        name: 'diffSorting',
        meta: {notCache: true, title: "差异分拣"},
        component: () => import('@/view/sorting/diffSorting')
      }
    ]
  },
  {
    path: '/preSorting',
    component: Main,
    children: [
      {
        path: '/sorting/preSorting',
        name: 'preSorting',
        meta: {notCache: true, title: "商品预分拣"},
        component: () => import('@/view/sorting/preSorting')
      }
    ]
  },
  {
    path: '/system',
    component: Main,
    children: [
      {
        path: '/system/setting',
        name: 'setting',
        meta: {notCache: true, title: "设置中心"},
        component: () => import('@/view/system/setting')
      }
    ]
  },
  {
    path: '/turnoverList',
    component: Main,
    children: [
      {
        path: '/system/turnoverList',
        name: 'turnoverList',
        meta: {notCache: true, title: "称重框管理"},
        component: () => import('@/view/system/turnoverList')
      }
    ]
  },
  /*{
    path: '/',
    component: Main,
    children: [
      {
        path: '/home',
        name: 'home',
        meta: {notCache:true},
        component: () => import('@/view/single-page/home')
      }
    ]
  },*/
  /*{
    path: '/message',
    name: 'message',
    component: Main,
    meta: {
      hideInBread: true,
      hideInMenu: true
    },
    children: [
      {
        path: 'message_page',
        name: 'message_page',
        meta: {
          title: '消息中心'
        },
        component: () => import('@/view/single-page/message/index.vue')
      }
    ]
  },
  {
    path: '/error_logger',
    name: 'error_logger',
    meta: {
      hideInBread: true,
      hideInMenu: true
    },
    component: Main,
    children: [
      {
        path: 'error_logger_page',
        name: 'error_logger_page',
        meta: {
          title: '错误收集'
        },
        component: () => import('@/view/single-page/error-logger.vue')
      }
    ]
  },
  {
    path: '/system',
    name: 'system',
    meta: {
      title: '系统设置'
    },
    component: Main,
    children: [
      {
        path: 'adminUser',
        name: 'adminUser',
        meta: {
          title: '用户管理'
        },
        component: () => import('@/view/system/adminUser.vue')
      },
      {
        path: '_role',
        name: '_role',
        meta: {
          title: '用户权限'
        },
        component: parentView,
        children: [
          {
            path: 'role',
            name: 'role',
            meta: {
              title: '角色管理'
            },
            component: () => import('@/view/system/role.vue')
          },
          {
            path: 'userRole',
            name: 'userRole',
            meta: {
              title: '用户角色'
            },
            // component: () => import('@/view/system/userRole.vue')
            component: () => import('@/view/system/adminUser.vue')
          }
        ]
      },
      {
        path: 'menus',
        name: 'menus',
        meta: {
          title: '菜单管理'
        },
        component: () => import('@/view/system/menus.vue')
      },
      {
        path: 'sysTask',
        name: 'sysTask',
        meta: {
          title: '任务调度'
        },
        component: () => import('@/view/system/sysTask.vue')
      }
    ]
  },*/
  /*{
    path: '/401',
    name: 'error_401',
    meta: {
      hideInMenu: true
    },
    component: () => import('@/view/error-page/401.vue')
  },
  {
    path: '/500',
    name: 'error_500',
    meta: {
      hideInMenu: true
    },
    component: () => import('@/view/error-page/500.vue')
  }*/
]



// WEBPACK FOOTER //
// ./src/router/routers.js